<template>
    <div :id="target" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                    <h5 class="modal-title">User Save Modal</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-7">
                            <div class="card">
                                <div class="card-header">
                                    <legend>
                                        <h5>Roles</h5>
                                        <div class="checkbox" style="position: absolute;top: 3%;left: 86%;" @click="selectAll">
                                            <label>
                                                <div class="uniform-checker border-success-600 text-success-800">
                                                    <span :class="{'checked':totalChecked}">
                                                        <input type="checkbox" name="checkbox" class="control-success" :checked="totalChecked">
                                                    </span>
                                                </div>
                                            </label>
                                        </div>
                                    </legend>
                                </div>
                                <div class="card-body">
                                    <ul class="tree-ul">
                                        <basic-tree class="item"
                                                    :item="treeData"
                                                    item-key="roleId"
                                                    item-title="roleNm"
                                                    :selected-item="selectedItem"
                                                    :keys="roles"
                                                    @emitItem="onItem"/>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="card">
                                <div class="card-header">
                                    <legend><h5>User Info</h5></legend>
                                </div>
                                <div class="card-body">
                                    <basic-input :vertical="true" label="Id" rule="required max:30" :disabled="!isCreateModal" v-model="userInfo.usrId"/>
                                    <basic-input :vertical="true" label="Type" rule="required max:50" v-model="userInfo.usrType"/>
                                    <basic-input :vertical="true" label="password" type="password" rule="symbol" v-model="userInfo.usrPw"/>
                                    <button class="btn bg-ums mt-3" style="width: 100%" @click="save" v-if="hasRole($const.ROLES.SETTINGS_USER_SAVE)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicInput from "@/components/form/input/BasicInput";
    import Select2 from "@/components/form/select/Select2";
    import validation from "@/config/mixin/validation";
    import api from '@/api/support'
    import BasicSwitch from "@/components/form/switch/BasicSwitch";
    import BasicTree from "@/components/treeview/BasicTree"
    export default {
        name: "UserSaveModal",
        components: {BasicInput,BasicTree},
        mixins:[validation],
        props: {
            target: {
                type:String,
                required: true
            },
            propsData: {
                type:Object,
                default() {
                    return {}
                }
            },
            userList: {
                type: Array
            },
            isCreateModal:Boolean
        },
        data() {
            return {
                modalWidth: window.innerWidth - 500,
                modalHeight: window.innerHeight - 150,
                userInfo:{
                    usrId:'',
                    usrNm:'',
                    usrType:'',
                    usrPw:'',
                },
                selectedItem:{},
                roles: []
            }
        },
        created() {
            window.addEventListener('resize', () => {
                this.resizeHandler()
            });
        },
        computed: {
            treeData: function() {
                return this.$const.ROLES_TREE
            },
            totalChecked: function() {
                return this.roles.length === Object.keys(this.$const.ROLES).length
            }
        },
        mounted() {
        },
        methods: {
            resizeHandler: function() {
                this.modalHeight = window.innerHeight - 300
                this.modalWidth = window.innerWidth -150
            },
            onItem: function (item) {
                this.selectedItem = $.extend(true,{},item)
                this.makeRoles()
            },
            makeRoles: function() {
                let position = this.roles.indexOf(this.selectedItem.roleId)
                if(position === -1) {
                    this.roles.push(this.selectedItem.roleId)
                } else if(!this.selectedItem.checked) {
                    this.roles.splice(position,1)
                }
            },
            selectAll: function() {
                if(this.roles.length > 0) {
                    this.roles = []
                } else {
                    $('.tree-ul').find('.tree-li').get().forEach((item)=>{
                        this.roles.push($(item)[0].dataset.row)
                    })
                }
            },
            save: function() {
                if(!this.validationCheck()) return
                if(this.isCreateModal) {
                    let filtered = this.userList.filter(item=>item.usrId === this.userInfo.usrId)
                    if(filtered.length > 0) {
                        this.$notify.alert('User is already exist');
                        return
                    }
                }
                this.userInfo.usrRole = this.roles.join(',')
                api.userSave(this.userInfo).then((result)=>{
                    if(result && result.data.code === 1000) {
                        this.$notify.success(result.data.message)
                        $("#"+this.target).modal('toggle')
                        this.$parent.search()
                    } else {
                        this.$notify.error('Fail',result.data.message)
                    }
                })
            },
        },
        watch: {
            'propsData':function(val) {
                this.userInfo = $.extend(true,{},val)
                let roles =  []
                if(val.usrRole) {
                    roles = val.usrRole.split(',')
                }
                this.roles = roles
            },
        }
    }
</script>

<style scoped>
    .modal-header .close {
        top:4% !important;
    }
    .modal-header {
        padding: 9px 19px !important;
    }
    ul {
        list-style: none;
    }
    legend {
        margin-bottom: 0px !important;
    }
</style>
